// extracted by mini-css-extract-plugin
export default {"dialogContainerOverride":"ModalCredentialForm_dialogContainerOverride__36B-A","formContainer":"ModalCredentialForm_formContainer__3kuSp"};